import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var Title = /*#__PURE__*/function () {
  function Title() {
    _classCallCheck(this, Title);
  }

  _createClass(Title, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value.length >= 1 && value.length <= 100;
    }
  }]);

  return Title;
}();